import { AbsenceReasonCategory } from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../Button';
import { ResponsiveDialog } from '../../../ResponsiveDialog/ResponsiveDialog';

export interface LateEarlyCreateOrUpdateDecisionDialogProps {
  type?: AbsenceReasonCategory.late | AbsenceReasonCategory.leftEarly;
  open: boolean;
  studentName?: string;
  cancelClick: () => void;
  replaceClick: () => void;
  addClick: () => void;
}

export const LateEarlyCreateOrUpdateDecisionDialog: FC<
  LateEarlyCreateOrUpdateDecisionDialogProps
> = ({ type, open, studentName, cancelClick, replaceClick, addClick }) => {
  const { t } = useTranslation();

  const header = t('classbook:absences:leftEarlyOrLate:replace_absence_entry_or_add', { defaultValue: 'Absenzeintrag ersetzen oder ergänzen' });

  const content = useMemo(() => {
    const typeTranslation =
      type === AbsenceReasonCategory.leftEarly
        ? t('classbook:absences:leftEarlyOrLate:late', { defaultValue: 'Verspätet' })
        : t('classbook:absences:leftEarlyOrLate:left_early', { defaultValue: 'Geht früher' });
    return t('classbook:absences:leftEarlyOrLate:students_absence_state_already_exist_create_new_or_update', { defaultValue: "{{studentName}} hat bereits den Status '{{typeTranslation}}'. Möchten Sie diesen ersetzen oder mit einem weiteren Absenzeintrag für {{studentName}} ergänzen?", studentName, typeTranslation });
  }, [t, type, studentName]);

  return (
    <ResponsiveDialog
      open={open}
      header={header}
      thirdAction={
        <Button onClick={cancelClick}>
          {t('classbook:absences:leftEarlyOrLate:cancel', { defaultValue: 'Abbrechen' })}
        </Button>
      }
      secondaryAction={
        <Button onClick={replaceClick}>
          {t('classbook:absences:leftEarlyOrLate:replace', { defaultValue: 'Ersetzen' })}
        </Button>
      }
      primaryAction={
        <Button appearance="primary" onClick={addClick}>
          {t('classbook:absences:leftEarlyOrLate:add', { defaultValue: 'Ergänzen' })}
        </Button>
      }
    >
      <span>{content}</span>
    </ResponsiveDialog>
  );
};
